import { SubscriptionPlan } from '@next-is-free-monorepo/next-is-free-types';

export type PlanFeature = 'accessCustomers' | 'quickLinks' | 'callToActions' | 'scheduleNotifications' | 'targetedNotifications' | 'apiAccess'

export const PLAN_FEATURES: Record<SubscriptionPlan, Record<PlanFeature, boolean>> = {
  starter: {
    accessCustomers: false,
    quickLinks: false,
    callToActions: false,
    scheduleNotifications: false,
    targetedNotifications: false,
    apiAccess: false,
  },
  essential: {
    accessCustomers: false,
    quickLinks: true,
    callToActions: true,
    scheduleNotifications: true,
    targetedNotifications: false,
    apiAccess: false,
  },
  advanced: {
    accessCustomers: true,
    quickLinks: true,
    callToActions: true,
    scheduleNotifications: true,
    targetedNotifications: true,
    apiAccess: true,
  },
  enterprise: {
    accessCustomers: true,
    quickLinks: true,
    callToActions: true,
    scheduleNotifications: true,
    targetedNotifications: true,
    apiAccess: true,
  }
};

export type PlanLimit = 'maxCustomers' | 'maxGoals' | 'maxSalesPoints' | 'maxStaffMembers'

export const PLAN_LIMITS: Record<SubscriptionPlan, Record<PlanLimit, number | 'unlimited'>> = {
  starter: {
    maxCustomers: 100,
    maxGoals: 2,
    maxSalesPoints: 1,
    maxStaffMembers: 1
  },
  essential: {
    maxCustomers: 1000,
    maxGoals: 4,
    maxSalesPoints: 3,
    maxStaffMembers: 5
  },
  advanced: {
    maxCustomers: 'unlimited',
    maxGoals: 'unlimited',
    maxSalesPoints: 10,
    maxStaffMembers: 'unlimited'
  },
  enterprise: {
    maxCustomers: 'unlimited',
    maxGoals: 'unlimited',
    maxSalesPoints: 'unlimited',
    maxStaffMembers: 'unlimited'
  }
};

export const planLimitsLabels: Record<keyof typeof PLAN_LIMITS['starter'], string> = {
  maxCustomers: 'Numero di clienti',
  maxGoals: 'Numero di Traguardi',
  maxSalesPoints: 'Numero di punti vendita massimi',
  maxStaffMembers: 'Membri dello staff',
};
